"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderTokensHost = void 0;
var react_1 = __importDefault(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var RenderToken_1 = require("./RenderToken");
var SiblingTokensContext_1 = require("./SiblingTokensContext");
var RenderListGroup_1 = require("./RenderList/RenderListGroup");
var RenderTokensHost = function (_a) {
    var e_1, _b;
    var tokens = _a.tokens;
    if (tokens.every(function (token) { return token.type === "inline"; })) {
        return (react_1.default.createElement(react_1.default.Fragment, null, tokens.map(function (token, index) {
            return react_1.default.createElement(RenderToken_1.RenderToken, { key: index, token: token, childTokens: [] });
        })));
    }
    var tokenChunks = [];
    try {
        for (var tokens_1 = __values(tokens), tokens_1_1 = tokens_1.next(); !tokens_1_1.done; tokens_1_1 = tokens_1.next()) {
            var token = tokens_1_1.value;
            (0, tiny_invariant_1.default)(token, "Token is undefined");
            if (token.type === "block") {
                switch (token.subType) {
                    case "listItem":
                        var listItemToken = token;
                        var listItemEntry = { token: listItemToken, children: [] };
                        var currentBlockChunk = tokenChunks[tokenChunks.length - 1];
                        if ((currentBlockChunk === null || currentBlockChunk === void 0 ? void 0 : currentBlockChunk.type) === "list") {
                            currentBlockChunk.listItems.push(listItemEntry);
                        }
                        else {
                            tokenChunks.push({ listItems: [listItemEntry], type: "list" });
                        }
                        break;
                    default:
                        tokenChunks.push({ token: token, children: [], type: "regular" });
                        break;
                }
            }
            else {
                var currentBlockChunk = tokenChunks[tokenChunks.length - 1];
                (0, tiny_invariant_1.default)(currentBlockChunk, "Current block chunk is undefined");
                switch (currentBlockChunk.type) {
                    case "regular":
                        currentBlockChunk.children.push(token);
                        break;
                    case "list":
                        var lastListItem = currentBlockChunk.listItems[currentBlockChunk.listItems.length - 1];
                        (0, tiny_invariant_1.default)(lastListItem, "Last list item is undefined");
                        lastListItem.children.push(token);
                        break;
                    default:
                        (0, tiny_invariant_1.default)(false, "Unknown chunk type");
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (tokens_1_1 && !tokens_1_1.done && (_b = tokens_1.return)) _b.call(tokens_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var renderedBlocks = tokenChunks.map(function (tokenChunk, index) {
        switch (tokenChunk.type) {
            case "regular":
                return react_1.default.createElement(RenderToken_1.RenderToken, { key: index, token: tokenChunk.token, childTokens: tokenChunk.children });
            case "list":
                return react_1.default.createElement(RenderListGroup_1.RenderListGroup, { key: index, listItems: tokenChunk.listItems });
            default:
                (0, tiny_invariant_1.default)(false, "Unknown chunk type");
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SiblingTokensContext_1.SiblingTokensContextProvider, { siblings: tokens }, renderedBlocks)));
};
exports.RenderTokensHost = RenderTokensHost;
